/**
 * Get modules of a certain type
 * @param store
 * @param feature store feature (core, product, category, etc)
 * @param moduleType type of module
 * @returns {Array}
 */
export function getModules(store, feature, moduleType) {
    const contentfulModules = _.get(store.getState(), `${feature}.landingPage.fields.modules`, []);

    if (_.isEmpty(moduleType)) {
        return contentfulModules;
    }

    return _.filter(contentfulModules, (m) => _.get(m, 'fields.contentType') === moduleType);
}

/**
 * Get components of a certain type
 * @param modules list of contentful modules
 * @param componentType type of component
 * @returns {Array}
 */
export function getComponents(modules, componentType) {
    return _.reduce(modules, (sum, module) => {
        Array.prototype.push.apply(sum, _.filter(_.get(module, 'fields.components', []), (c) => _.get(c, 'sys.contentType.sys.id') === componentType));
        return sum;
    }, []);
}

/**
 * Helper function to extract .fields from any object, defaulting to an empty object
 * @param fields
 */
export function getFields({ fields = {} }) {
    return fields;
}
